/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CompanyBlockInput = {
    readonly effectiveDateTime?: any | null;
    readonly companyId: string;
    readonly clientMutationId?: string | null;
};
export type CompanyBlockMutation_MutationVariables = {
    readonly input: CompanyBlockInput;
};
export type CompanyBlockMutation_MutationResponse = {
    readonly companyBlock: ({
        readonly clientMutationId: string | null;
    }) | null;
};
export type CompanyBlockMutation_Mutation = {
    readonly response: CompanyBlockMutation_MutationResponse;
    readonly variables: CompanyBlockMutation_MutationVariables;
};



/*
mutation CompanyBlockMutation_Mutation(
  $input: CompanyBlockInput!
) {
  companyBlock(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CompanyBlockInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "companyBlock",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CompanyBlockInput!"
      }
    ],
    "concreteType": "CompanyBlockPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "CompanyBlockMutation_Mutation",
  "id": null,
  "text": "mutation CompanyBlockMutation_Mutation(\n  $input: CompanyBlockInput!\n) {\n  companyBlock(input: $input) {\n    clientMutationId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CompanyBlockMutation_Mutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "CompanyBlockMutation_Mutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
(node as any).hash = 'ad7fcf7eb6db57eccf496dbc90d3fbf3';
export default node;
